<div class="sz-day-strip">
  <div class="sz-day-strip__cells">
    @for (active of days(); track $index) {
      <div class="sz-day-strip__cell" [class.sz-day-strip__cell--on]="active"></div>
    }
  </div>
  @if (startLabel() || endLabel()) {
    <div class="sz-day-strip__axis">
      <span class="sz-day-strip__axis-label">{{ startLabel() }}</span>
      <span class="sz-day-strip__axis-label">{{ endLabel() }}</span>
    </div>
  }
</div>
